import { getMomentMinStr                    } from '../util.js';
import { getMomentMinStrOptionalWithDefault } from '../util.js';
import { convertDurationSecToStr            } from '../util.js';

export const BAN_TYPE_TEMP = 1; // temporary
export const BAN_TYPE_PERM = 2; // permanent

export function getBanDurationTypeOptions() {
  return [
    {value: BAN_TYPE_TEMP, text: 'временная блокировка'},
    {value: BAN_TYPE_PERM, text: 'постоянная блокировка'},
  ];
}

export const BAN_LOG_ITEM_TYPE_BAN   = 1;
export const BAN_LOG_ITEM_TYPE_UNBAN = 2;

export function isPlayerBanned(banData, now) {
  if(banData === null) {
    return false;
  }

  if(!banData.isBanned) {
    return false;
  }
  if(banData.ftime === 0) {
    // Player was banned permanently.
    return true;
  }

  // Player was banned temporarily.
  return now < banData.ftime;
}

export function getPlayerBanStatusStr(banData, now) {
  const NOT_BANNED_STR = 'Player is not banned.';

  if(banData === null) {
    return NOT_BANNED_STR;
  }
  if(!banData.isBanned) {
    return NOT_BANNED_STR;
  }

  if(banData.ftime === 0) {
    return 'Player was banned permanently.';
  }
  if(now < banData.ftime) {
    const banEndStr = getMomentMinStr(banData.ftime);
    return 'Player is banned until ' + banEndStr + '.';
  }

  // ban ended
  return 'Player is not banned.';
}

export function getPlayerBanPlannedDuration(ban) {
  return ban.ftime - ban.ctime;
}

export function getPlayerBanPlannedDurationStr(ban) {
  if(ban.ftime === 0) {
    return 'forever';
  }
  const plannedDuration = getPlayerBanPlannedDuration(ban)
  return convertDurationSecToStr(plannedDuration);
}

export function getPlayerBanFtimeStr(ftime) {
  return getMomentMinStrOptionalWithDefault(ftime, 'endless');
}

export function getDurationType(ftime) {
  if(ftime === 0) {
    return BAN_TYPE_PERM;
  }
  return BAN_TYPE_TEMP;
}

export function getDurationTypeName(durationType) {
  switch(durationType) {
    case BAN_TYPE_TEMP: return 'temporary';
    case BAN_TYPE_PERM: return 'permanent';
  }
  return `Unknown duration type ${durationType}.`;
}

export function getBanDurationTypeName(ban) {
  const durationType = getDurationType(ban.ftime);
  return getDurationTypeName(durationType);
}